// ManageAnnouncements.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from './CannabisRetailerApp';

const ManageAnnouncements = ({ onEdit, onBack }) => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      const snapshot = await getDocs(collection(db, 'Announcements'));
      const list = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setAnnouncements(list);
    };
    fetchAnnouncements();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this announcement?')) {
      await deleteDoc(doc(db, 'Announcements', id));
      setAnnouncements(prev => prev.filter(a => a.id !== id));
    }
  };

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold">Manage Announcements</h2>
        {onBack && (
          <button type="button" onClick={onBack} className="text-sm text-gray-600">Back</button>
        )}
      </div>

      {announcements.map((a) => (
        <div key={a.id} className="bg-white shadow rounded p-4 mb-4">
          {a.heading && <h2 className="text-lg font-bold">{a.heading}</h2>}
          {a.subheading && <h3 className="text-md text-gray-700 mb-2">{a.subheading}</h3>}
          {a.imageUrl && <img src={a.imageUrl} alt="" className="my-2 max-h-40 object-contain" />}
          {a.bulletPoints?.length > 0 && (
            <ul className="list-disc pl-5 mb-2">
              {a.bulletPoints.map((p, i) => <li key={i}>{p}</li>)}
            </ul>
          )}
          {a.paragraph && <p className="text-sm whitespace-pre-line text-gray-800 mb-2">{a.paragraph}</p>}

          <div className="mt-4 flex gap-4">
            {onEdit && (
              <button
                onClick={() => onEdit(a)}
                className="text-blue-600 hover:underline"
              >
                Edit
              </button>
            )}
            <button
              onClick={() => handleDelete(a.id)}
              className="text-red-600 hover:underline"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ManageAnnouncements;
